import { type NavigationContentProps } from '~/utils'

export const DefaultNavigationContent = (_props: NavigationContentProps) => null
